"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const dom_utils_1 = require("../../../../utils/dom-utils");
const gallery = document.querySelector(".gallery");
window.addEventListener("load", () => {
    if (gallery) {
        const items = (0, dom_utils_1.queryAll)(".gallery__item");
        const overlay = createDiv();
        items.forEach((item) => {
            const imageItem = item.querySelector('img');
            if (imageItem) {
                const rowHeight = 15;
                const rowSpan = Math.ceil((item.clientHeight + 15) / rowHeight);
                item.style.gridRowEnd = `span ${rowSpan}`;
                item.addEventListener("click", () => {
                    const image = imageItem.src;
                    showImage(image, overlay);
                });
            }
        });
    }
});
const showImage = (image, overlay) => {
    const img = overlay.querySelector("img");
    document.body.style.overflow = "hidden";
    img.src = image;
    overlay.scrollIntoView({ behavior: "smooth", block: "center" });
    overlay.style.visibility = "visible";
};
const createDiv = () => {
    const parent = document.querySelector(".gallery");
    const overlay = document.createElement("div");
    overlay.className = "gallery__overlay";
    overlay.style.visibility = "hidden";
    const hideBtn = document.createElement("button");
    hideBtn.className = "hide-button";
    const img = document.createElement("img");
    hideBtnHandler(hideBtn, overlay);
    overlay.appendChild(hideBtn);
    overlay.appendChild(img);
    parent.appendChild(overlay);
    return overlay;
};
const hideBtnHandler = (button, overlay) => {
    button.addEventListener("click", () => {
        overlay.style.visibility = "hidden";
        document.body.style.overflow = "auto";
    });
};
